import React from "react";

export default function Input({
  id,
  name,
  type,
  autocomplete,
  className,
  placeholder,
  value,
  onChange,
  required = true,
  ...others
}) {
  return (
    <input
      id={id}
      name={name}
      type={type || "text"}
      autoComplete={autocomplete}
      className={className}
      placeholder={placeholder}
      required={required}
      value={value}
      onChange={onChange}
      {...others}
    />
  );
}
